/**
 * Metadados de stablecoins por rede (chainId hex).
 * Fonte única de verdade para endereços/decimais, usada em:
 * - TransferForm
 * - WalletConnectionContext (saldo de stablecoins)
 * - useIncomingTransferNotification (detecção de recebimentos)
 */
export const STABLECOIN_METADATA_BY_CHAIN = {
  // Ethereum mainnet
  '0x1': [
    { symbol: 'USDC', address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48', decimals: 6 },
    { symbol: 'USDT', address: '0xdAC17F958D2ee523a2206206994597C13D831ec7', decimals: 6 },
  ],
  // Polygon
  '0x89': [
    { symbol: 'USDC', address: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174', decimals: 6 },
    { symbol: 'USDT', address: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F', decimals: 6 },
  ],
  // Arbitrum One
  '0xa4b1': [
    { symbol: 'USDC', address: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831', decimals: 6 },
    { symbol: 'USDT', address: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9', decimals: 6 },
  ],
  // Base mainnet
  '0x2105': [
    { symbol: 'USDC', address: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913', decimals: 6 },
    { symbol: 'USDT', address: '0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2', decimals: 6 },
  ],
  // Base Sepolia (testnet)
  '0x14a34': [
    { symbol: 'USDC', address: '0x036CbD53842c5426634e7929541eC2318f3dCF7e', decimals: 6 },
  ],
  // Ethereum Sepolia (testnet)
  '0xaa36a7': [
    { symbol: 'USDC', address: '0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238', decimals: 6 },
  ],
};

/**
 * Mapa simplificado chainId -> { [symbol]: address }
 * Mantido para compatibilidade com código existente.
 */
export const STABLECOIN_CONTRACTS = Object.fromEntries(
  Object.entries(STABLECOIN_METADATA_BY_CHAIN).map(([chainId, tokens]) => [
    chainId,
    tokens.reduce((acc, token) => {
      acc[token.symbol] = token.address;
      return acc;
    }, {}),
  ]),
);

export const ERC20_TRANSFER_ABI = [
  'function transfer(address to, uint256 amount) returns (bool)',
  'function decimals() view returns (uint8)',
];

/** ABI para leitura de eventos Transfer (ex.: useIncomingTransferNotification). */
export const ERC20_ABI_WITH_TRANSFER_EVENT = [
  'event Transfer(address indexed from, address indexed to, uint256 value)',
  'function decimals() view returns (uint8)',
];

/** Seletor ERC-20 balanceOf(address) para eth_call. */
export const ERC20_BALANCEOF_SELECTOR = '0x70a08231';
